import script from "./OpenAiIntegrationFormPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./OpenAiIntegrationFormPage.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__